// extracted by mini-css-extract-plugin
export var root = "PlasmicListItem-module--root--36jPq";
export var slotTitle = "PlasmicListItem-module--slotTitle--3-Vhg";
export var slotDate = "PlasmicListItem-module--slotDate--1pcS3";